import { useStrict } from 'mobx';
import Articles from 'modules/Articles/Store';
import Families from 'modules/Families/Store';
import Customers from 'modules/Customers/Store';
import Taxes from 'modules/Taxes/Store';
import Users from 'modules/Users/Store';
import UI from 'modules/UI/Store';
import Branches from 'modules/Branches/Store';
import Stock from 'modules/Stock/Store';
import SettingsInvoice from 'modules/SettingsInvoice/Store';
import Dashboard from 'modules/Dashboard/Store';
import Reports from 'modules/Reports/Store';
import BusinessUnits from 'modules/BusinessUnits/Store';
import OperationLines from 'modules/OperationLines/Store';
import ReceipLayout from 'modules/ReceiptLayouts/Store';
import PassengerCategories from './modules/PassengerCategories/Store';
import Stretches from 'modules/Stretches/Store';
import DashboardTicket from 'modules/DashboardTicket/Store';
import LicenseStore from 'modules/Licenses/Store';
import DeviceStore from 'modules/Devices/Store';
import VoucherStore from 'modules/Vouchers/Store';
import PacketStore from 'modules/Packets/Store';
import ScheduleStore from 'modules/Schedules/Store';
import CollaboratorStore from 'modules/Collaborators/Store';
import AcountStore from 'modules/Acount/Store';
import PacketArticleStore from 'modules/PacketArticles/Store';
import AfiliateStore from 'modules/Afiliates/Store';
import DiscountReasonStore from 'modules/DiscountReasons/Store';
import SettingCashMovementStore from './modules/SettingCashMovements/Store';
import HeadboardStore from './modules/Headboards/HeadboardStore';
import CollaboratorStretchStore from './modules/CollaboratorStretches/Store';
import LogStore from './modules/Logs/Store';
import MovementProviderStore from './modules/MovementProviders/Store';
import UsedGaugeStore from './modules/UsedGauges/UsedGaugeStore';
import ExtraStore from './modules/Extras/ExtraStore';
import OtaStore from './modules/Otas/OtaStore';
import CollaboratorPacketStore from './modules/CollaboratorPackets/Store';
import CollaboratorPacketTicketsStore from './modules/CollaboratorPacketTickets/Store';
import MoneysStore from './modules/Moneys/MoneyStore';
// import ManifestStore from './modules/Manifest/ManifestStore'
import VehiclesStore from './modules/Vehicles/Store';
import { TempDuePaymentsStore } from './modules/Reports/TempDuePaymentsStore';
import DiscountCodesStore from './modules/DiscountCodes/DiscountCodesStore';
import CartsStore from './modules/Carts/CartStore';
import DestinationsStore from './modules/Destinations/DestinationsStore';
import CategoriesStore from './modules/Categories/CategoriesStore';
import TagsStore from './modules/Tags/TagsStore';
import RegionsStore from './modules/Regions/RegionsStore';
import MarketingStore from './modules/Marketings/MarketingStore';
import StretchPriceDateStore from './modules/StretchPriceDates/Store';
import CivitripClientsStore from './modules/Acount/Civitrip/Store';
import PaylandsStore from './modules/Paylands/PaylandsStore';
import ResourceStore from './modules/Resources/Store';
import PaymentGatewaysStore from './modules/PaymentGateways/Store';
import PaymentGatewayOptionsStore from './modules/PaymentGatewayOptions/Store';
useStrict(true);
var Store = /** @class */ (function () {
    function Store() {
        this.articles = new Articles();
        this.families = new Families();
        this.customers = new Customers();
        this.taxes = new Taxes();
        this.UI = new UI();
        this.users = new Users();
        this.branches = new Branches();
        this.stock = new Stock();
        this.settingsInvoice = new SettingsInvoice();
        this.dashboard = new Dashboard();
        this.reports = new Reports();
        this.businessUnits = new BusinessUnits();
        this.operationLines = new OperationLines();
        this.receipLayouts = new ReceipLayout();
        this.passengerCategories = new PassengerCategories();
        this.stretches = new Stretches();
        this.dashboardTicket = new DashboardTicket();
        this.licenses = new LicenseStore();
        this.devices = new DeviceStore();
        this.voucherStore = new VoucherStore();
        this.packetStore = new PacketStore();
        this.scheduleStore = new ScheduleStore();
        this.collaboratorStore = new CollaboratorStore();
        this.acountStore = new AcountStore();
        this.packetArticleStore = new PacketArticleStore();
        this.afiliateStore = new AfiliateStore();
        this.discountReasonStore = new DiscountReasonStore();
        this.settingCashMovementStore = new SettingCashMovementStore();
        this.headboardStore = new HeadboardStore();
        this.collaboratorStretchesStore = new CollaboratorStretchStore();
        this.logs = new LogStore();
        this.movementProviderStore = new MovementProviderStore();
        this.usedGaugeStore = new UsedGaugeStore();
        this.extraStore = new ExtraStore();
        this.otaStore = new OtaStore();
        this.collaboratorPacketsStore = new CollaboratorPacketStore();
        this.collaboratorPacketTicketsStore = new CollaboratorPacketTicketsStore();
        this.moneysStore = new MoneysStore();
        // manifestStore: ManifestStore = new ManifestStore()
        this.vehiclesStore = new VehiclesStore();
        this.tempDuePaymentsStore = new TempDuePaymentsStore();
        this.discountCodesStore = new DiscountCodesStore();
        this.cartsStore = new CartsStore();
        this.regionsStore = new RegionsStore();
        this.destinationsStore = new DestinationsStore();
        this.categoriesStore = new CategoriesStore();
        this.tagsStore = new TagsStore();
        this.marketingStore = new MarketingStore();
        this.datePricesStore = new StretchPriceDateStore();
        this.civitripClientsStore = new CivitripClientsStore();
        this.paylandsStore = new PaylandsStore();
        this.resourcesStore = new ResourceStore();
        this.paymentGawewaysStores = new PaymentGatewaysStore();
        this.paymentGatewayOptionsStore = new PaymentGatewayOptionsStore();
    }
    return Store;
}());
export default Store;



//////////////////
// WEBPACK FOOTER
// ./src/Store.ts
// module id = 659
// module chunks = 0